module.exports = __webpack_public_path__ + "static/img/5.b8698e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-fr/5.jpg
// module id = FJvw
// module chunks = 1